import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

type StatusTheme = 'pending' | 'success' | 'danger'

interface BookingStatusHeaderProps {
  title: string
  theme: StatusTheme
  onClick: () => void
}

export const BookingStatusHeader = ({
  title,
  theme,
  onClick,
}: BookingStatusHeaderProps) => {
  return (
    <button
      className={s.statusButton}
      onClick={onClick}
    >
      <div className={clsx(s.statusBadge, s[theme])}>
        <span className="semi-bold-12">{title}</span>
      </div>

      <div className={clsx(s.statusIconWrapper, s[theme])}>
        <AppIcon
          id={AllIcons.INFO_CIRCLE}
          width={14}
          height={14}
          className={s.statusIcon}
        />
      </div>
    </button>
  )
}
